export const ORDER_VIEW = Object.freeze({
    CANCEL: { label: "Cancel Request", value: "CANCEL" },
    TIP_DRIVER: { label: "Tip Driver", value: "TIP_DRIVER" },
    DELIVERY_COMPLETE: {
      label: "Delivery Complete",
      value: "DELIVERY_COMPLETE",
    },
    DRIVER_TIPPED: { label: "Driver Tipped", value: "DRIVER_TIPPED" },
  });
  